


























import Vue from 'vue'

export default Vue.extend({
  props: {
    type: {
      type: String as () =>
        | 'top'
        | 'primary'
        | 'secondary'
        | 'default'
        | 'text',
      default: 'default',
    },
    iconBefore: {
      type: String as () => string | null,
      default: null,
    },
    iconAfter: {
      type: String as () => string | null,
      default: null,
    },
    href: {
      type: String as () => string | null,
      default: null,
    },
    to: {
      type: String as () => string | null,
      default: null,
    },
    // 幅100％にする
    block: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    // 幅を固定する
    fixed: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as () => 'sm' | 'md' | 'lg',
      default: 'md',
    },
    // TODO: ローディング状態
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inversed: {
      type: Boolean,
      default: false,
    },
  },
})
